<template>
  <div v-if="umsokn">
    <v-col>
      <div class="forms__header">
        {{ t('lan_greidslufrest_umsokn_step2_header1') }}
      </div>

      <div v-for="(deptor, index) in umsokn.coDeptors" :key="index">
        <div v-if="index > 0">
          <div class="forms__divider__container">
            <v-btn
              v-if="!disable"
              density="comfortable"
              variant="text"
              class="forms__warning__list__wrapper"
              @click="removeCoDeptor(index)"
              :aria-label="t('general_remove')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <div class="forms__divider"></div>
          </div>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :disabled="disable"
              :label="t('lan_greidslufrest_umsokn_step2_nafn')"
              :placeholder="t('lan_greidslufrest_umsokn_step2_nafn')"
              variant="outlined"
              v-model="deptor.name"
              autocomplete="name"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              :disabled="disable"
              :label="t('lan_greidslufrest_umsokn_step2_kennitala')"
              :placeholder="t('lan_greidslufrest_umsokn_step2_kennitala')"
              variant="outlined"
              v-model="deptor.ssn"
              inputmode="numeric"
              maxlength="11"
              @update:modelValue="(v:string)=>deptor.ssn=formatKennitala(v)"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :disabled="disable"
              :label="t('lan_greidslufrest_umsokn_step2_simi')"
              :placeholder="t('lan_greidslufrest_umsokn_step2_simi')"
              variant="outlined"
              v-model="deptor.phone"
              inputmode="tel"
              @update:modelValue="(v:string)=>deptor.phone = v.replace(/[^0-9]/g,'')"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              :disabled="disable"
              :label="t('lan_greidslufrest_umsokn_step2_email')"
              :placeholder="t('lan_greidslufrest_umsokn_step2_email')"
              variant="outlined"
              v-model="deptor.email"
              autocomplete="email"
            />
          </v-col>
        </v-row>
      </div>

      <div class="m-t-40" v-if="!disable">
        <v-btn
          color="primary"
          variant="outlined"
          prepend-icon="mdi-plus"
          class="mt-4"
          @click="addCoDeptor"
        >
          {{ $t('lan_greidslufrest_umsokn_step2_add') }}
        </v-btn>
      </div>
    </v-col>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

type Deptor = { name: string; ssn: string; phone: string; email: string }
type Umsokn = { coDeptors?: Deptor[] } & Record<string, any>

const { umsokn, onLoaded } = useUmsokn()

const props = defineProps<{
  handleNext?: (form?: { $touch: () => void; $invalid: boolean }) => void
  handlePrev?: () => void
  umsokn: Umsokn
  disable?: boolean
}>()

const { t } = useI18n()

onLoaded(() => {
  if (!Array.isArray(props.umsokn.coDeptors)) props.umsokn.coDeptors = []
  if (props.umsokn.coDeptors.length === 0) {
    props.umsokn.coDeptors.push({ name: '', ssn: '', phone: '', email: '' })
  }
})

function addCoDeptor() {
  props.umsokn.coDeptors!.push({ name: '', ssn: '', phone: '', email: '' })
}

function removeCoDeptor(index: number) {
  props.umsokn.coDeptors!.splice(index, 1)
}

function formatKennitala(v: string): string {
  // Keep digits only and insert dash after 6 digits: XXXXXX-XXXX
  const digits = (v || '').replace(/\D/g, '').slice(0, 10)
  if (digits.length <= 6) return digits
  return `${digits.slice(0, 6)}-${digits.slice(6)}`
}
</script>

<style scoped>
.forms__header { font-weight: 700; margin-bottom: 16px; }
.forms__divider__container { position: relative; margin: 16px 0; }
.forms__warning__list__wrapper { padding: 0; min-width: 0; }
.forms__divider { height: 1px; width: 100%; background: #e0e0e0; }
.forms__button__container { display: flex; gap: 12px; justify-content: center; margin-top: 24px; }
.forms__button__forward { color: #fff; }
.forms__button__add { text-transform: none; }
</style>
